"use strict";
/**
 * Encore Foundation - 7.11.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.violetSet = exports.tanSet = exports.stormSet = exports.spearmintSet = exports.salmonSet = exports.royalBlueSet = exports.orangeSet = exports.neonGreenSet = exports.midnightSet = exports.maroonSet = exports.lavenderSet = exports.graySet = exports.goldSet = exports.fuchsiaSet = exports.forestSet = exports.citricSet = exports.chocolateSet = exports.brightRedSet = exports.boleSet = exports.azureSet = exports.aubergineSet = void 0;
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.aubergineSet = {
    background: {
        base: '#503659',
        highlight: '#503659',
        press: '#503659',
        elevated: { base: '#503659', highlight: '#503659', press: '#503659' },
        tinted: { base: '#503659', highlight: '#503659', press: '#503659' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#684674' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.azureSet = {
    background: {
        base: '#0078d6',
        highlight: '#0078d6',
        press: '#0078d6',
        elevated: { base: '#0078d6', highlight: '#0078d6', press: '#0078d6' },
        tinted: { base: '#0078d6', highlight: '#0078d6', press: '#0078d6' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#008af6' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.boleSet = {
    background: {
        base: '#b06239',
        highlight: '#b06239',
        press: '#b06239',
        elevated: { base: '#b06239', highlight: '#b06239', press: '#b06239' },
        tinted: { base: '#b06239', highlight: '#b06239', press: '#b06239' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#c5754b' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.brightRedSet = {
    background: {
        base: '#e91429',
        highlight: '#e91429',
        press: '#e91429',
        elevated: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
        tinted: { base: '#e91429', highlight: '#e91429', press: '#e91429' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#ee3a4c' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.chocolateSet = {
    background: {
        base: '#834f34',
        highlight: '#834f34',
        press: '#834f34',
        elevated: { base: '#834f34', highlight: '#834f34', press: '#834f34' },
        tinted: { base: '#834f34', highlight: '#834f34', press: '#834f34' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#9c5e3e' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.citricSet = {
    background: {
        base: '#608109',
        highlight: '#608109',
        press: '#608109',
        elevated: { base: '#608109', highlight: '#608109', press: '#608109' },
        tinted: { base: '#608109', highlight: '#608109', press: '#608109' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#6f950a' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.forestSet = {
    background: {
        base: '#056952',
        highlight: '#056952',
        press: '#056952',
        elevated: { base: '#056952', highlight: '#056952', press: '#056952' },
        tinted: { base: '#056952', highlight: '#056952', press: '#056952' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#067d62' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.fuchsiaSet = {
    background: {
        base: '#e1118c',
        highlight: '#e1118c',
        press: '#e1118c',
        elevated: { base: '#e1118c', highlight: '#e1118c', press: '#e1118c' },
        tinted: { base: '#e1118c', highlight: '#e1118c', press: '#e1118c' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#f03ca7' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.goldSet = {
    background: {
        base: '#bc5900',
        highlight: '#bc5900',
        press: '#bc5900',
        elevated: { base: '#bc5900', highlight: '#bc5900', press: '#bc5900' },
        tinted: { base: '#bc5900', highlight: '#bc5900', press: '#bc5900' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#d86600' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.graySet = {
    background: {
        base: '#777777',
        highlight: '#777777',
        press: '#777777',
        elevated: { base: '#777777', highlight: '#777777', press: '#777777' },
        tinted: { base: '#777777', highlight: '#777777', press: '#777777' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#898989' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.lavenderSet = {
    background: {
        base: '#8e66ac',
        highlight: '#8e66ac',
        press: '#8e66ac',
        elevated: { base: '#8e66ac', highlight: '#8e66ac', press: '#8e66ac' },
        tinted: { base: '#8e66ac', highlight: '#8e66ac', press: '#8e66ac' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#9d7bb7' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.maroonSet = {
    background: {
        base: '#8a202b',
        highlight: '#8a202b',
        press: '#8a202b',
        elevated: { base: '#8a202b', highlight: '#8a202b', press: '#8a202b' },
        tinted: { base: '#8a202b', highlight: '#8a202b', press: '#8a202b' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#ac2835' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.midnightSet = {
    background: {
        base: '#202f72',
        highlight: '#202f72',
        press: '#202f72',
        elevated: { base: '#202f72', highlight: '#202f72', press: '#202f72' },
        tinted: { base: '#202f72', highlight: '#202f72', press: '#202f72' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#2b3f99' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.neonGreenSet = {
    background: {
        base: '#148a08',
        highlight: '#148a08',
        press: '#148a08',
        elevated: { base: '#148a08', highlight: '#148a08', press: '#148a08' },
        tinted: { base: '#148a08', highlight: '#148a08', press: '#148a08' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#179e09' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.orangeSet = {
    background: {
        base: '#d84000',
        highlight: '#d84000',
        press: '#d84000',
        elevated: { base: '#d84000', highlight: '#d84000', press: '#d84000' },
        tinted: { base: '#d84000', highlight: '#d84000', press: '#d84000' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#f84a00' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.royalBlueSet = {
    background: {
        base: '#283ea3',
        highlight: '#283ea3',
        press: '#283ea3',
        elevated: { base: '#283ea3', highlight: '#283ea3', press: '#283ea3' },
        tinted: { base: '#283ea3', highlight: '#283ea3', press: '#283ea3' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#324dcb' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.salmonSet = {
    background: {
        base: '#e41d63',
        highlight: '#e41d63',
        press: '#e41d63',
        elevated: { base: '#e41d63', highlight: '#e41d63', press: '#e41d63' },
        tinted: { base: '#e41d63', highlight: '#e41d63', press: '#e41d63' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#e94780' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.spearmintSet = {
    background: {
        base: '#438270',
        highlight: '#438270',
        press: '#438270',
        elevated: { base: '#438270', highlight: '#438270', press: '#438270' },
        tinted: { base: '#438270', highlight: '#438270', press: '#438270' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#4d9681' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.stormSet = {
    background: {
        base: '#537aa1',
        highlight: '#537aa1',
        press: '#537aa1',
        elevated: { base: '#537aa1', highlight: '#537aa1', press: '#537aa1' },
        tinted: { base: '#537aa1', highlight: '#537aa1', press: '#537aa1' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#678cb2' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.tanSet = {
    background: {
        base: '#a56753',
        highlight: '#a56753',
        press: '#a56753',
        elevated: { base: '#a56753', highlight: '#a56753', press: '#a56753' },
        tinted: { base: '#a56753', highlight: '#a56753', press: '#a56753' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#b37b69' },
};
/**
 *
 * ![Status: experimental](https://img.shields.io/badge/EXPERIMENTAL-yellow|height=14)
 */
exports.violetSet = {
    background: {
        base: '#b02897',
        highlight: '#b02897',
        press: '#b02897',
        elevated: { base: '#b02897', highlight: '#b02897', press: '#b02897' },
        tinted: { base: '#b02897', highlight: '#b02897', press: '#b02897' },
    },
    text: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    essential: {
        base: '#ffffff',
        subdued: '#ffffff',
        brightAccent: '#ffffff',
        negative: '#ffffff',
        warning: '#ffffff',
        positive: '#ffffff',
        announcement: '#ffffff',
    },
    decorative: { base: '#ffffff', subdued: '#cd2fb0' },
};
